import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaStar,
  FaRocket,
  FaEye,
  FaUsers,
  FaCheckCircle,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const AffordableVideoProductionCompanyInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Affordable Video Production Company in Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Quality Meets Affordability</Subheading>}
        heading={
          <Heading>
            Affordable <span tw="text-primary-500">Video Production</span> in
            Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we provide affordable video production services
            in **Dubai**, delivering high-quality, engaging videos that elevate
            your brand without breaking the bank. From corporate films to social
            media content, we craft visuals that captivate and convert.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1626447852944-a375e7629e3b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1580537659466-0a9bfa916a54?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1513258496099-48168024aec0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Get a Quote Now"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Cost-Effective Video Production in Dubai"
        description="We deliver professional videos at budget-friendly prices."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "High-Quality Output",
            description:
              "4K videos with professional editing at affordable rates.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted by Clients",
            description: "Proven track record with startups and SMEs.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Turnaround",
            description: "Quick delivery to meet tight deadlines.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Engaging Content",
            description: "Videos that capture attention and drive results.",
          },
          {
            icon: <FaUsers color="#ff5464" size={40} />,
            title: "Client-Centric",
            description: "Tailored solutions to fit your budget and vision.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Versatile Services",
            description: "Corporate, promotional, and social media videos.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Affordable Video Production Process"
        description={
          <Description>
            We create stunning videos without compromising quality:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your goals and budget.</li>
              <li>Planning: Develop cost-effective scripts and storyboards.</li>
              <li>Filming: Use advanced equipment for high-quality visuals.</li>
              <li>Editing: Enhance with professional post-production tools.</li>
              <li>Delivery: Provide polished videos within days.</li>
              <li>Revisions: Offer unlimited revisions for satisfaction.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1616469829581-77edf95863c9?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1540655037529-dec987208707?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1502086223501-7ea6ecd79368?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Affordable Video Wins in Dubai"
        description="Our budget-friendly videos deliver impactful results."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Startup Success",
            description: "Boosted a startup’s reach with a promo video.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Brand Visibility",
            description: "Increased engagement for a local business.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "95% approval from cost-conscious clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Affordable Excellence?</Subheading>}
        heading="Top Affordable Video Production in Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for affordable video production services
            in Dubai. Get high-quality, engaging videos that fit your
            budget—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1574717024453-354056afd83e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1518135714426-c18f5ffb6f4d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1523741543316-beb7fc7023d8?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
